"use strict";

exports.__esModule = true;
exports.ClassificationButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _VimanaIcon = require("../../VimanaIcon");
var _Theme = require("../../Theme");
var _getPlantStateColor = require("../../PlantStateActivities/getPlantStateColor");
var _UserAction = require("../../UserActions/UserAction");
var _userActionsContext = require("../../UserActions/userActionsContext");
var _excluded = ["state", "activity", "disabled", "onClickAction", "rank", "onClassifyClick", "userActions"];
var _class, _ClassificationButton;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var WorkflowPanel = _styledComponents["default"].div.withConfig({
  displayName: "ClassificationButtonlegacy__WorkflowPanel",
  componentId: "sc-j5oc9l-0"
})(["background:", ";padding-right:0.3rem;display:flex;justify-content:center;"], function (_ref) {
  var state = _ref.state,
    theme = _ref.theme;
  return (0, _getPlantStateColor.getPlantStateColor)(theme, state.id);
});
var ClassificationButtonView = _styledComponents["default"].button.withConfig({
  displayName: "ClassificationButtonlegacy__ClassificationButtonView",
  componentId: "sc-j5oc9l-1"
})(["box-sizing:border-box;display:flex;flex:1;justify-content:center;align-items:center;font-weight:bold;font-size:1.2rem;padding:", ";color:", ";background:", ";border:none;border-radius:2px;box-shadow:0 2px 2px 0 rgba(0,0,0,0.14),0 1px 2px 0 rgba(0,0,0,0.12),0 3px 1px -2px rgba(0,0,0,0.2);position:relative;bottom:0;left:0;transition:all 0.05s linear;outline:none;overflow:hidden;opacity:", ";transform:translate3d(0,0,0);&.", "{font-size:1.8rem;padding:", ";}&:hover{cursor:pointer;outline:none;}&[disabled]:hover{bottom:0;left:0;cursor:default;box-shadow:none;outline:none;}&:after{content:\"\";display:block;position:absolute;width:100%;height:100%;top:0;left:0;pointer-events:none;background-image:radial-gradient(circle,#fff 10%,transparent 10.01%);background-repeat:no-repeat;background-position:50%;transform:scale(10,10);opacity:0;transition:transform 0.5s,opacity 1s;}&:active:after{transform:scale(0,0);opacity:0.3;transition:0s;}&[disabled]:active{bottom:0;left:0;box-shadow:none;outline:none;}"], (0, _Theme.val)("ButtonPaddingSmall"), (0, _Theme.val)("SecondaryButtonColor"), function (_ref2) {
  var state = _ref2.state,
    theme = _ref2.theme;
  return (0, _getPlantStateColor.getPlantStateColor)(theme, state.id);
}, function (props) {
  return props.disabled ? "0.6" : "1";
}, _core.Classes.LARGE, (0, _Theme.val)("ButtonPaddingSmall"));

/**
 * Allows an operator to classify a cycle according to the given state / activity.
 */
var ClassificationButton = exports.ClassificationButton = (0, _userActionsContext.withUserActionsContext)(_class = (_ClassificationButton = /*#__PURE__*/function (_Component) {
  function ClassificationButton() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleClick = function (invoke) {
      var _this$props = _this.props,
        state = _this$props.state,
        activity = _this$props.activity,
        rank = _this$props.rank,
        onClassifyClick = _this$props.onClassifyClick;
      if (typeof onClassifyClick === "function") {
        onClassifyClick({
          state: state,
          activity: activity,
          rank: rank
        });
        if (invoke) {
          invoke();
        }
      }
    };
    _this.body = function (invoke) {
      var _this$props2 = _this.props,
        state = _this$props2.state,
        activity = _this$props2.activity,
        disabled = _this$props2.disabled,
        onClickAction = _this$props2.onClickAction,
        rank = _this$props2.rank,
        onClassifyClick = _this$props2.onClassifyClick,
        userActions = _this$props2.userActions,
        extra = _objectWithoutPropertiesLoose(_this$props2, _excluded);
      var clickedAction = onClickAction && userActions && userActions.find(function (action) {
        return action.name === onClickAction.name;
      });
      return /*#__PURE__*/_react["default"].createElement(ClassificationButtonView, _extends({
        state: state
      }, extra, {
        disabled: disabled,
        type: "button",
        onClick: function onClick() {
          return _this.handleClick(invoke);
        }
      }), clickedAction && /*#__PURE__*/_react["default"].createElement(WorkflowPanel, {
        state: state
      }, /*#__PURE__*/_react["default"].createElement(_VimanaIcon.VimanaIcon, {
        margin: "0",
        icon: clickedAction.icon,
        iconSize: 20,
        alt: clickedAction.name
      })), activity ? activity.name : state.name);
    };
    return _this;
  }
  _inheritsLoose(ClassificationButton, _Component);
  var _proto = ClassificationButton.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var onClickAction = this.props.onClickAction;
    if (!onClickAction) {
      return this.body();
    }
    return /*#__PURE__*/_react["default"].createElement(_UserAction.UserAction, onClickAction, function (_ref3) {
      var invoke = _ref3.invoke;
      return _this2.body(invoke);
    });
  };
  return ClassificationButton;
}(_react.Component), _ClassificationButton.defaultProps = {
  rank: 0
}, _ClassificationButton)) || _class;